import { FC } from 'react';

interface PlaceholderAsLabelProps {
  placeholder?: any;
  value?: any;
  children?: React.ReactNode;
  size?: 'large' | 'middle' | 'small';
}

export const PlaceholderAsLabel: FC<PlaceholderAsLabelProps> = ({
  placeholder,
  value,
  children,
  size = 'large',
}) => {
  return (
    <div className="relative mb-1">
      <span
        className={`absolute top-0 left-2 flex items-center max-w-[calc(100%-16px)]
           text-[12px] leading-[13px] text-placeholder bg-white px-[2px] z-[2] h-[2px]
           transition-all ease-out duration-200
          ${placeholder !== false && value ? 'visible ease-out duration-200' : 'invisible'}
          ${size === 'small' ? 'left-2 !text-[11px] !px-[1px]' : 'left-[12px]'} `}
      >
        {placeholder}
      </span>
      {children}
    </div>
  );
};
